import React from "react";

/**
 * SpecialDisclaimer — Table-level footer disclaimers, fully backend-driven.
 * Row 1 = Default (miniTableDisclaimer1) + Off Market (miniTableDisclaimer2).
 * Row 2 = Co Listed (miniTableDisclaimer3) + Custom Property Type (miniTableDisclaimer4).
 * Each row collapses: 0 visible -> not rendered, 1 visible -> centered, 2 visible -> side by side.
 * Rendered below the table in normal/print view only, not in action modes.
 */
function SpecialDisclaimer({
  custom
}) {
  const {
    offMarketDisclaimer,
    coListingDiscliamer,
    showRegularDisclaimer,
    disclaimerStyles,
    miniTableDisclaimer1,
    miniTableDisclaimer2,
    miniTableDisclaimer3,
    miniTableDisclaimer4,
  } = custom;

  const row1 = [
    { key: "default", text: miniTableDisclaimer1, show: showRegularDisclaimer },
    { key: "offMarket", text: miniTableDisclaimer2, show: offMarketDisclaimer },
  ].filter((d) => d.show && d.text);

  const row2 = [
    { key: "coListed", text: miniTableDisclaimer3, show: coListingDiscliamer },
    // Custom Property Type has no backend flag — shows whenever text is present.
    { key: "customPropertyType", text: miniTableDisclaimer4, show: true },
  ].filter((d) => d.show && d.text);

  const renderRow = (row, rowClassName) =>
    row.length > 0 && (
      <div
        className={`mini-table-footer-row ${rowClassName || ""} ${row.length === 1 ? "mini-table-footer-row-single" : ""}`}
      >
        {row.map((d) => (
          <div key={d.key} className="off-market-disclaimer-text">
            {d.text}
          </div>
        ))}
      </div>
    );

  return (
    <>
      {renderRow(row1, disclaimerStyles)}
      {renderRow(row2)}
    </>
  );
}

export default SpecialDisclaimer;
